module.exports = __webpack_public_path__ + "static/media/SYSTEMATRIXLOGO.c8eb6eae.png";